var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "iconmonstr-pencil-filled",
    d: "M4.481,15.659C3.147,19.575,3,19.891,3,20.246A.749.749,0,0,0,3.75,21c.352,0,.668-.137,4.574-1.492ZM5.541,14.6l3.846,3.846L20.708,7.133a1,1,0,0,0,0-1.413L18.273,3.288a1,1,0,0,0-1.413,0Z",
    transform: "translate(-3.001 -2.995)",
    fill: "#22c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.a87d0c7c875bd91854f5da2a6c7120dc.svg";
export { ForwardRef as ReactComponent };